var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "new_releases"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_8763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_8763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "new_releases_2",
    d: "M9.1 22.5L7.2 19.3L3.6 18.5L3.95 14.8L1.5 12L3.95 9.2L3.6 5.5L7.2 4.7L9.1 1.5L12.5 2.95L15.9 1.5L17.8 4.7L21.4 5.5L21.05 9.2L23.5 12L21.05 14.8L21.4 18.5L17.8 19.3L15.9 22.5L12.5 21.05L9.1 22.5ZM9.95 19.95L12.5 18.85L15.1 19.95L16.5 17.55L19.25 16.9L19 14.1L20.85 12L19 9.85L19.25 7.05L16.5 6.45L15.05 4.05L12.5 5.15L9.9 4.05L8.5 6.45L5.75 7.05L6 9.85L4.15 12L6 14.1L5.75 16.95L8.5 17.55L9.95 19.95ZM11.45 15.55L17.1 9.9L15.7 8.45L11.45 12.7L9.3 10.6L7.9 12L11.45 15.55Z",
    fill: "#127E08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bf1ed60e87e7b13bfa2a91d1968b6b37.svg";
export { ForwardRef as ReactComponent };